module.exports = __webpack_public_path__ + "static/media/slack.8089fc1d.png";